import { isTV } from "../utils/platform";

export type InputDevice = "gamepad" | "keyboard" | "mouse" | "touch";
let lastInputDevice: InputDevice | undefined;

export const getLastInputDevice = () => lastInputDevice;

export const setLastInputDevice = (device: InputDevice) => {
  lastInputDevice = device;
};

export const resetLastInputDevice = () => {
  lastInputDevice = undefined;
};

export const trackInputDevices = (): (() => void) => {
  // A TV remote reaches the page as key events, but it is a controller.
  const onKeyDown = () => setLastInputDevice(isTV ? "gamepad" : "keyboard");

  const onPointerDown = (event: PointerEvent) =>
    setLastInputDevice(event.pointerType === "mouse" ? "mouse" : "touch");

  // Pre-pointer-events fallback (older TV browsers).
  const onMouseDown = () => setLastInputDevice("mouse");
  const onTouchStart = () => setLastInputDevice("touch");

  const hasPointerEvents = "PointerEvent" in window;

  window.addEventListener("keydown", onKeyDown, true);
  if (hasPointerEvents) {
    window.addEventListener("pointerdown", onPointerDown, true);
  } else {
    window.addEventListener("mousedown", onMouseDown, true);
    window.addEventListener("touchstart", onTouchStart, true);
  }

  return () => {
    window.removeEventListener("keydown", onKeyDown, true);
    if (hasPointerEvents) {
      window.removeEventListener("pointerdown", onPointerDown, true);
    } else {
      window.removeEventListener("mousedown", onMouseDown, true);
      window.removeEventListener("touchstart", onTouchStart, true);
    }
  };
};
